import { apiSlice } from "./apiSlice";
import { OUTLET_URL } from "../constants";

const outletApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // createFoodItem: builder.mutation({
    //   query: (data) => ({
    //     url: `${OUTLET_URL}/createFoodItem`,
    //     method: "POST",
    //     body: data,
    //     headers: {
    //       Authorization: `Bearer ${data.token}`,
    //     },
    //   }),
    // }),
    getOutletsForCustomers: builder.query({
      query: (data) => ({
        url: `${OUTLET_URL}/getOutletsForCustomers?${
          data?.query ? data?.query : ""
        }`,
        method: "GET",
        // headers: {
        //   Authorization: `Bearer ${data?.token}`,
        // },
      }),
    }),
  }),
});

export const { useGetOutletsForCustomersQuery } = outletApiSlice;
